import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import talentActions from '../../actions';
import { tableConfig } from '../../../../../settings/index';
import Api from '../../../../../helpers/api';
import { sendRequest } from '../../../../../helpers/saga';
import { logger } from '../../../../../helpers/logger';
import notifications from '../../../../../redux/notifications/actions';

const api = new Api('workers/:id/shifts/past');

function* loadData({ payload }) {
  try {
    const {
      page = 1,
      pageSize = tableConfig.pageSize,
      column = 'finishes_at',
      order = 'descend',
      filter = '',
      job_group_id,
      id,
      expand,
      currentPage,
    } = payload;

    const isLoadMoreClicked = job_group_id && expand;

    const search = {
      ...payload,
      pageSize,
      column,
      order,
      filter,
      id,
      page: isLoadMoreClicked ? 1 : page, // When load more has been clicked set page to 1 but increase pageSize
    };

    yield put(talentActions.loadData({ id }));

    const { jobList } = yield all({
      jobList: call(sendRequest, api.load, { search, id }, notifications.REQUEST_ERROR),
    });

    if (jobList?.data?.success?.data) {
      const { records, totalCount, filteredCount, sortableColumns, filters, job_group, saved_searches } =
        jobList.data.success.data;

      const result = {
        data: records,
        filteredTotal: filteredCount,
        filters,
        jobGroup: job_group,
        pageSize,
        savedSearches: saved_searches,
        sortableColumns,
        total: totalCount,
      };

      if (job_group && expand) {
        yield put(actions.loadMultiDayDataSuccess({ currentPage, ...result }));
      } else {
        yield put(actions.loadDataSuccess(result));
      }
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, loadData)]);
}
